// Centralized Day Hire brand tokens
export const BRAND = {
  name: "Day Hire",
  tagline: "Good neighbors, hired by the day",
  region: "Moscow–Pullman",
  logo: "/logo-dayhire.png",
  colors: {
    plum: "#3E2A4E",
    plumDark: "#2E1F3B",
    chartreuse: "#D9FF3D",
    chartreuseDark: "#C6EB2D",
    violetWhite: "#F3EFFA",
    charcoal: "#23272B",
    cardTint: "#FFFFFF",
    cardTintDeep: "#EBE4F5",
  },
};

export const DayHireMark = ({ size = 36, withWordmark = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <img src={BRAND.logo} alt="Day Hire" width={size} height={size} style={{ width: size, height: size, objectFit: "contain", borderRadius: size * 0.22 }} />
    {withWordmark && (
      <span className="font-heading font-black tracking-tight text-[#3E2A4E]" style={{ fontSize: size * 0.55 }}>DAY HIRE</span>
    )}
  </span>
);

export default BRAND;
